import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import config from "../../config";
import { getPremiumAccount } from "../../services/Premium";
import { premiumPaths } from "../../pages/Premium/navigation";

function SideMenu() {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const { userName } = useAuth();
  const [showPaymentsMenu, setShowPaymentsMenu] = useState(false);

  const { accessToken, checkPermission, isLoggedIn } = useAuth();
  const isPremiumAdmin = checkPermission("Zarządzanie użytkownikami");
  const navigate = useNavigate();
  const location = useLocation();

  const userInitials = () => {
    if (!userName) return "X";
    try {
      return userName.split(" ")[0][0] + userName.split(" ")[1][0];
    } catch {
      return "X";
    }
  };

  const handleNavClick = (e, targetPath) => {
    const current = location.pathname + location.search + location.hash;
    if (current === targetPath) {
      e.preventDefault();
      navigate(targetPath, {
        replace: true,
        state: { __refresh: Date.now() },
      });
    }
  };

  useEffect(() => {
    if (!accessToken || !isLoggedIn) {
      setIsPremium(false);
      return;
    }
    getPremiumAccount(accessToken)
      .then((account) => setIsPremium(account?.Active === true))
      .catch(() => setIsPremium(false));
  }, [accessToken, isLoggedIn]);

  return (
    <nav>
      <div
        className="d-flex flex-column flex-shrink-0 text-white bg-secondary"
        style={{ width: "270px", height: "100vh" }}
      >
        <div className="navbar-collapse p-1" id="sidebarCollapse">
          <div>
            <span className="d-flex flex-column align-items-center pb-1 my-1">
              <img
                src="/assets/images/kig-e7Ti-vgY.png"
                className="mx-auto"
                alt="..."
              />
              <span className="text-white" style={{ fontSize: "0.75rem" }}>
                KRAJOWA IZBA GOSPODARCZA
              </span>
            </span>
          </div>
          <ul className="navbar-nav mb-auto">
            {!checkPermission("Obsługa wysyłki") && (
              <li className="nav-item mb-0">
                <Link
                  to="/application/list"
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                  onClick={(e) => handleNavClick(e, "/application/list")}
                >
                  <div className="me-auto fs-5">
                    <svg className="bi me-1" width="16" height="16">
                      <use xlinkHref="#table"></use>
                    </svg>
                    Moje wnioski
                  </div>
                </Link>
              </li>
            )}
            {!checkPermission("Obsługa wniosków") &&
              !checkPermission("Obsługa wysyłki") && (
                <li className="mb-0 pt-xxl-1">
                  <Link
                    to="/application/edit/1/00000000-0000-0000-0000-000000000000"
                    className="btn btn-primary ms-2 h2 fs-5"
                    style={{ color: "#FFFFFF" }}
                    onClick={(e) =>
                      handleNavClick(
                        e,
                        "/application/edit/1/00000000-0000-0000-0000-000000000000",
                      )
                    }
                  >
                    Utwórz wniosek
                  </Link>
                </li>
              )}
            {!checkPermission("Obsługa wniosków") &&
              !checkPermission("Obsługa wysyłki") && (
                <li className="nav-item mb-0">
                  <Link
                    to="/business/list"
                    className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                    onClick={(e) => handleNavClick(e, "/business/list")}
                  >
                    <div className="me-auto fs-5">
                      <svg className="bi me-1" width="16" height="16">
                        <use xlinkHref="#building"></use>
                      </svg>
                      Moje firmy
                    </div>
                  </Link>
                </li>
              )}
            {!isPremiumAdmin && !checkPermission("Obsługa wniosków") &&
              !checkPermission("Obsługa wysyłki") && (
                <li className="nav-item mb-0">
                  <NavLink
                    to={premiumPaths.home}
                    className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                    style={{ display: isPremium ? undefined : "none" }}
                    onClick={(e) => handleNavClick(e, premiumPaths.home)}
                  >
                    <div className="me-auto fs-5">
                      <i className="bi bi-lightning-charge me-1"></i>
                      Konto Premium
                    </div>
                  </NavLink>
                </li>
              )}
            <li className="nav-item mb-0">
              <Link
                to="/certificate/internalcheck"
                className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                onClick={(e) => handleNavClick(e, "/certificate/internalcheck")}
              >
                <div className="me-auto fs-5">
                  <svg className="bi me-1" width="16" height="16">
                    <use xlinkHref="#search"></use>
                  </svg>
                  Sprawdź świadectwo
                </div>
              </Link>
            </li>
            {checkPermission("Potwierdzanie płatności") && (
              <li className="nav-item mb-0">
                <div
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                  onClick={() => setShowPaymentsMenu(!showPaymentsMenu)}
                >
                  <div
                    className="me-auto fs-5 d-flex justify-content-between align-items-center"
                    onClick={() => {
                      setShowPaymentsMenu(!showPaymentsMenu);
                      navigate("/application/toPay");
                    }}
                  >
                    <span>
                      <svg className="bi me-1" width="16" height="16">
                        <use xlinkHref="#grid"></use>
                      </svg>
                      Płatności
                    </span>
                    <i
                      className={`bi ${
                        showPaymentsMenu ? "bi-chevron-up" : "bi-chevron-down"
                      }`}
                    ></i>
                  </div>
                </div>
                {showPaymentsMenu && (
                  <ul
                    className={`navbar-nav ms-3 fade ${
                      showPaymentsMenu ? "fade-in" : ""
                    }`}
                  >
                    <li className="nav-item mb-0">
                      <Link
                        to="/application/toPay"
                        className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                      >
                        Wnioski do opłaty
                      </Link>
                    </li>
                    {/* <li className="nav-item mb-0">
                                            <Link
                                                to="/application/list"
                                                className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                                            >
                                                Płatności odroczone
                                            </Link>
                                        </li> */}
                  </ul>
                )}
              </li>
            )}

            {checkPermission("Obsługa wysyłki") && (
              <li className="nav-item mb-0">
                <Link
                  to="/application/shipping"
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                  onClick={(e) => handleNavClick(e, "/application/shipping")}
                >
                  <div className="me-auto fs-5">
                    <i className="bi bi-truck me-1" width="16" height="16" />
                    Wysyłki
                  </div>
                </Link>
              </li>
            )}

            {isPremiumAdmin && (
              <li className="nav-item">
                <NavLink
                  to={premiumPaths.home}
                  onClick={(e) => handleNavClick(e, premiumPaths.home)}
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                >
                  <div className="me-auto fs-5">
                    <i className="bi bi-buildings me-1" />
                    Firmy Premium
                  </div>
                </NavLink>
              </li>
            )}

            {checkPermission("Zarządzanie użytkownikami") && (
              <li className="nav-item">
                <Link
                  to="/user/list"
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                  onClick={(e) => handleNavClick(e, "/user/list")}
                >
                  <div className="me-auto fs-5">
                    <svg className="bi me-1" width="16" height="16">
                      <use xlinkHref="#people-circle"></use>
                    </svg>
                    Użytkownicy
                  </div>
                </Link>
              </li>
            )}

            {checkPermission("Zarządzanie użytkownikami") && (
              <li className="nav-item">
                <Link
                  to="/settings"
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                  onClick={(e) => handleNavClick(e, "/settings")}
                >
                  <div className="me-auto fs-5">
                    <i className="bi bi-gear me-1"></i>
                    Ustawienia systemowe
                  </div>
                </Link>
              </li>
            )}

            {(checkPermission("Raport podstawowy") ||
              checkPermission("Raport zaawansowany") ||
              checkPermission("Raport odroczonych należności")) && (
              <li className="nav-item">
                <Link
                  to="/report"
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                >
                  <div className="me-auto fs-5">
                    <i className="bi bi-graph-up me-1"></i>
                    Raporty
                  </div>
                </Link>
              </li>
            )}
            {checkPermission("Logi pocztowe") && (
              <li className="nav-item">
                <Link
                  to="/maillogs"
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
                  onClick={(e) => handleNavClick(e, "/maillogs")}
                >
                  <div className="me-auto fs-5">
                    <i className="bi bi-envelope-check me-1"></i>
                    Logi serwera pocztowego
                  </div>
                </Link>
              </li>
            )}
          </ul>
        </div>
        <div className="dropdown px-1 pb-1 w-100">
          {
            <ul
              className={`ms-1 nav nav-pills flex-column fade ${
                showUserMenu ? "show" : ""
              }`}
              aria-labelledby="dropdownUser1"
            >
              {!isLoggedIn && (
                <li className="nav-item mb-0">
                  <Link
                    to="/Login"
                    className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white fs-5"
                  >
                    <i className="bi-box-arrow-in-left me-1"></i>
                    Zaloguj
                  </Link>
                </li>
              )}
              <li className="nav-item mb-0">
                <Link
                  to="/user/profile"
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white fs-5"
                >
                  <i className="bi-person me-1"></i>
                  Edytuj profil
                </Link>
              </li>
              <li className="nav-item mb-0">
                <Link
                  to="/Logout"
                  className="btn btn-outline-primary w-100 ms-0 border-0 menu-item-white fs-5"
                >
                  <i className="bi-box-arrow-right me-1"></i>
                  Wyloguj
                </Link>
              </li>
            </ul>
          }
          <div
            href="#"
            className="d-flex align-items-center text-decoration-none btn btn-outline-primary w-100 ms-0 border-0 menu-item-white"
            id="dropdownUser1"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            {/* <img src="/assets/images/user.svg" alt="" width="32" height="32" /> */}
            <div className="rounded-circle border p-0 me-1 w1 h1 fs-6 menu-item-white">
              <div style={{ position: "relative", left: "2px", top: "3px" }}>
                {userInitials()}
              </div>
            </div>
            <div className="fs-5">{userName}</div>
            <div className="ms-auto">
              <i
                className={`bi ${
                  showUserMenu ? "bi-chevron-up" : "bi-chevron-down"
                }`}
              ></i>
            </div>
          </div>

          <div className="d-flex flex-row">
            <span className="text-white text-opacity-50 very-small ms-auto">
              {config.info.version}
            </span>
          </div>
        </div>
        <div className="d-flex flex-column bg-dark text-white fs-6 p-1">
          <div className="d-flex justify-content-center">
            <a
              href="/dokumenty/Regulamin_serwisu_eCO-wazny_od_06-05-2025.pdf"
              target="_blank"
              className="text-white mb-1"
            >
              Regulamin serwisu
            </a>
          </div>
          <div className="d-flex justify-content-center">
            {config.info.meta.name}
          </div>
          <div className="d-flex justify-content-center">
            {config.info.meta.address}
          </div>
          <div className="d-flex justify-content-center">
            {config.info.meta.bussinesData}
          </div>
          <div className="d-flex justify-content-center">
            e-mail:&nbsp;
            <a href={`mailto:${config.info.meta.email}`} className="text-white">
              {config.info.meta.email}
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default SideMenu;
